import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/* eslint-disable */
export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/
    );
};
/* eslint-enable */

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); 
    }, [pathname]);

    return null;
};
export default ScrollToTop;

export const validateLoadMore = (data, meta) => {
  if (data?.length < meta?.total && meta?.offset + meta?.limit < meta?.total) {
    return true;
  }

  return false;
};

export const validatePassword = (password) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);

  if (!hasUpperCase || !hasLowerCase || !hasNumber || password.length < 8) {
    return false;
  }

  return true;
};

export const user = () => {
  return JSON.parse(localStorage.getItem('auth')) ?? false;
};

export const parseNum = (n) => {
  if(0 <= n && n < 10000){
    return n;
  } else if(10000 <= n && n < 1000000) {
    return (Math.floor(n / 1000)) + 'K';
  } else if(1000000 <= n) {
    return (Math.floor(n / 1000000)) + 'M';
  } 
};

export const getInitials = (firstName, lastName) => {
  if (!firstName && !lastName) { 
    return ''; 
  }

  const firstInitial = firstName ? firstName.charAt(0) : '';
  const lastInitial = lastName ? lastName.charAt(0) : '';
  return `${firstInitial}${lastInitial}`.toUpperCase();
};

export const parseDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); 
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

export const parseDateTime = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); 
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  return `${hours}:${minutes} ${day}/${month}/${year}`;
};

export const parseFullDate = (isoDate) => {
  if (!isoDate) { return 'Soon'; }

  try {
    const date = new Date(isoDate);
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayOfWeek = daysOfWeek[date.getUTCDay()];

    const day = date.getUTCDate();
    const suffix = (day) => {
        if (day >= 11 && day <= 13) { return 'th'; }
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const month = months[date.getUTCMonth()];

    let hours = date.getUTCHours();
    let minutes = date.getUTCMinutes();
    let ampm = 'AM';

    if (hours >= 12) {
        ampm = 'PM';
        if (hours > 12) { hours -= 12; }
    }
    if (hours === 0) { hours = 12; }
    minutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${dayOfWeek} ${day}${suffix(day)} of ${month} at ${hours}:${minutes}${ampm} AEST`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Soon';
  }
};

export const formatDateTime = (isoDate) => {
    if (!isoDate) { return 'Ended'; }

    try {
        const date = new Date(isoDate);

        let hours = date.getUTCHours();
        let minutes = date.getUTCMinutes();
        let ampm = 'am';

        if (hours >= 12) {
            ampm = 'pm';
            if (hours > 12) { hours -= 12; }
        }
        if (hours === 0) { hours = 12; }
        minutes = minutes < 10 ? `0${minutes}` : minutes;

        // Получаем день
        const day = date.getUTCDate();

        // Получаем месяц
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const month = months[date.getUTCMonth()];

        // Получаем год
        const year = date.getUTCFullYear();

        return `${hours}:${minutes}${ampm} ${day} ${month} ${year}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'Ended';
    }
};

export const countdownTimer = (targetDate, setTimeLeft) => {
    if (!targetDate) { return; }

    const updateTimer = () => {
        const now = new Date();
        const eventDate = new Date(targetDate);
        const diff = eventDate - now;

        if (diff <= 0) {
            setTimeLeft(''); 
            return;
        }

        const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
        const months = Math.floor((diff % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24 * 30));
        const days = Math.floor((diff % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        let formattedTime = '';

        if (years > 0) { formattedTime += `${String(years).padStart(2, '0')}y `; }
        if (months > 0 || years > 0) { formattedTime += `${String(months).padStart(2, '0')}m `; }
        if (days > 0 || months > 0 || years > 0) { formattedTime += `${String(days).padStart(2, '0')}d `; }

        formattedTime += `${String(hours).padStart(2, '0')}h `;
        formattedTime += `${String(minutes).padStart(2, '0')}m `;
        formattedTime += `${String(seconds).padStart(2, '0')}s`;

        setTimeLeft(formattedTime.trim());
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000); 

    return () => clearInterval(interval);
};

export const parseMessageDate = (dateString) => {
  const date = new Date(dateString);

  const now = new Date();
  const secondsPast = (now.getTime() - date.getTime()) / 1000;

  if (secondsPast < 60) { // < 1m
    return 'Just now';
  }
  if (secondsPast < 3600) { // <  1h
    const minutes = Math.floor(secondsPast / 60);
    return `${minutes} min. ago`;
  }
  if (secondsPast < 86400) { // < 1day
    const hours = Math.floor(secondsPast / 3600);
    return `${hours}h. ago`;
  }

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

export const getAge = (birthDate) => {
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age;
};

export const parseDateBirthday = (dateString) => {
  if(!dateString){
    return null;
  }
  
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); 
  const year = date.getUTCFullYear();
  return `${year}-${month}-${day}`;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const formatExpireDate = (date, days = 30) => {
  if (!date) {return '';}

  const d = new Date(date);
  d.setDate(d.getDate() + days);

  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const calculateProgress = (value, maxValue) => {
  const percent = (value / maxValue) * 100;
  return `${Math.min(Math.round(percent), 100)}%`; 
};

export const interestsOptions = () => {
  return [
    'Music', 'Sports', 'Travel', 'Movies', 'Gaming', 'Reading',
    'Cooking', 'Dancing', 'Art', 'Technology', 'Fitness', 'Photography',
    'Nature', 'Fashion', 'Anime',
    'Hiking', 'Camping', 'Running', 'Swimming', 'Yoga', 'Meditation',
    'Astronomy', 'Science', 'Psychology', 'Philosophy', 'History', 'Politics',
    'Languages', 'Writing', 'Poetry', 'Painting', 'Drawing', 'DIY',
    'Gardening', 'Cars', 'Motorcycles', 'Aviation', 'Space', 'Coding',
    'Startups', 'Crypto', 'AI', 'Esports', 'Board Games', 'Chess',
    'Volunteering', 'Animals', 'Dogs', 'Cats', 'Coffee', 'Tea',
    'Food', 'Baking', 'Wine', 'Traveling', 'Beaches', 'Mountains',
    'Urban Exploring', 'Minimalism', 'Sustainability', 'Interior Design', 'Makeup', 'Skincare',
    'Tattoos', 'Piercing', 'Festivals', 'Photography Film', 'Vintage', 'Comics',
    'Manga', 'KPop', 'Movies Classic', 'Standup', 'Podcasts', 'Collecting',
    'Traveling Solo', 'Surfing', 'Snowboarding', 'Hiking Trails', 'Nudes'
  ];
};